<template>
  <section id="contact">
    <div class="wrap">
      <div class="section-head">
        <div>
          <h2>{{ title }}</h2>
          <p class="lead">{{ lead }}</p>
        </div>
      </div>
      <div class="cards">
        <article class="card fade-in">
          <div class="kicker">Email</div>
          <h3>
            <a
              :href="`mailto:${email}`"
              style="text-decoration:none;color:inherit;"
            >
              {{ email }}
            </a>
          </h3>
          <p>Share a short overview (strategy, team, target size, track record highlights) and we'll follow up promptly.</p>
        </article>
        <article class="card fade-in">
          <div class="kicker">Materials</div>
          <h3>Data-room ready</h3>
          <p>We provide a concise checklist for DDQ, track record, pipeline, terms, and references to accelerate diligence.</p>
        </article>
        <article class="card fade-in">
          <div class="kicker">Locations</div>
          <h3>{{ locations }}</h3>
          <p>Global LP coverage across pensions, insurers, endowments, foundations, and family offices.</p>
        </article>
      </div>
      <div class="sep"></div>
      <div class="small">
        <strong>&capital</strong> — Independent placement for independent managers.<br>
        This website is intended for professional investors and qualified clients. Nothing herein constitutes an offer to sell or a solicitation of an offer to buy any security or investment product. Any offering will be made only pursuant to definitive documentation.
      </div>
      <div class="sep"></div>
      <div class="small mono">
        © {{ currentYear }} &capital — and-capital.co.uk. All rights reserved.
        <span style="opacity: 0.4; margin-left: 12px; font-size: 11px;">v{{ buildVersion }}</span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: "Let's talk"
  },
  lead: {
    type: String,
    default: "If you're preparing for market—or want an honest read on timing, structure, and fit—drop us a line."
  },
  email: {
    type: String,
    default: 'hello@and-capital.co.uk'
  },
  locations: {
    type: String,
    default: 'London • New York • Los Angeles'
  }
});

const currentYear = ref(new Date().getFullYear());
const buildVersion = ref(__BUILD_VERSION__);

onMounted(() => {
  // Update year annually
  currentYear.value = new Date().getFullYear();
});
</script>

<style scoped>
/* Contact section styles are inherited from global styles.css */
/* Component-specific overrides can go here if needed */
</style>
